import type { StorefrontMood } from './moods';
import { MoodIcon } from './MoodIcon';

export function MoodCard({
  mood,
  selected,
  onSelect,
}: {
  mood: StorefrontMood;
  selected: boolean;
  onSelect: (mood: StorefrontMood) => void;
}) {
  return (
    <label className={`mood-card mood-${mood.id}${selected ? ' is-selected' : ''}`}>
      <input
        type="radio"
        name="storefront-mood"
        value={mood.code}
        checked={selected}
        onChange={() => onSelect(mood)}
      />
      {selected && (
        <span className="mood-check" aria-hidden="true">
          ✓
        </span>
      )}
      <span className="mood-symbol" aria-hidden="true">
        <MoodIcon iconKey={mood.iconKey} />
      </span>
      <strong>{mood.label}</strong>
    </label>
  );
}
